import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';

import IconQuestion from '@creditflowresearch/uilib/Icon/IconQuestion';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

import styles from './styles.module.scss';

interface IProps {
  sections: { id?: string, description: string }[],
  dataTest: string,
  className?: string,
}

export const RestrictedSections = ({ sections, dataTest, className = '' }: IProps) => {
  if (isEmpty(sections)) return null;

  return (
    <div className={ cn(styles.restrictedSectionsContainer, className) }>
      { sections.map(({ id, description }) => (
        <div
          key={ id }
          data-test={ dataTest }
          className={ styles.restrictedSection }
        >
          <p className={ styles.restrictedSectionTitle }>
            <span>Restricted Content</span>
            <Tooltip
              content="Access to this content is limited to select users"
            >
              <IconQuestion className={ styles.restrictedSectionTitleIcon } />
            </Tooltip>
          </p>
          { description && (
            <div
              className={ styles.restrictedSectionDescription }
              data-test={ `${ dataTest }Description` }
            >
              <div dangerouslySetInnerHTML={ { __html: description } } />
            </div>
          ) }
        </div>
      )) }
    </div>
  );
};
